export const SET_LOGIN_REDIRECT_URL = '[url] set login redirect url';

export interface SetLoginRedirectUrl {
  payload: { loginRedirectUrl: string };
  type: typeof SET_LOGIN_REDIRECT_URL;
}
